import { render, staticRenderFns } from "./RightItemGroup.vue?vue&type=template&id=4ab20ef2&scoped=true&"
import script from "./RightItemGroup.vue?vue&type=script&lang=js&"
export * from "./RightItemGroup.vue?vue&type=script&lang=js&"
import style0 from "./RightItemGroup.vue?vue&type=style&index=0&id=4ab20ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab20ef2",
  null
  
)

export default component.exports